import { z } from 'zod/v4'

const measurementIdSchema = z
  .string()
  .trim()
  .transform((value) => value.toUpperCase())
  .pipe(
    z
      .string()
      .max(64)
      .regex(/^G-[A-Z0-9]+$/, 'Enter a Google Analytics 4 Measurement ID, like G-XXXXXXXXXX.')
  )

export const googleAnalyticsIntegrationSchema = z.object({
  measurement_id: measurementIdSchema,
})

export function normalizeGoogleAnalyticsMeasurementId(value: string | null | undefined): string {
  return String(value ?? '')
    .trim()
    .toUpperCase()
}
